import { MainValueOptions, ReportSettings } from './reportSettings.ts';

interface Props {
    reportSettings: ReportSettings;
    setReportSettings: (reportSettings: ReportSettings) => void;
    targetValueEnabled: boolean;
}

/**
 * Controls whether bars are scaled by percentage or absolute value.
 * Also controls the target value.
 */
export function ReportTargetControl({
    reportSettings,
    setReportSettings,
    targetValueEnabled,
}: Props) {
    return (
        <section className='report-controls__section'>
            <div className='report-controls__heading'>Target value</div>
            <div className='report-controls__segmented'>
                {MainValueOptions.map((value) => (
                    <button
                        key={value}
                        type='button'
                        className={reportSettings.mainValue === value ? 'selected' : undefined}
                        onClick={() => setReportSettings({ ...reportSettings, mainValue: value })}
                    >
                        {value}
                    </button>
                ))}
            </div>
            {targetValueEnabled && (
                <label className='report-controls__target'>
                    <span>Target</span>
                    <input
                        type='number'
                        min={0}
                        max={1}
                        step={0.01}
                        value={reportSettings.availabilityTargetValue || ''}
                        onChange={(event) => setReportSettings({
                            ...reportSettings,
                            availabilityTargetValue: event.target.value,
                        })}
                    />
                </label>
            )}
        </section>
    );
}
